import { v4 as uuidV4 } from 'uuid'
import { uploadFile } from '@weblite/file'
import {
  showConnectionProblemSnackbar,
  showUploadingImageSnackbar,
} from '$comp/snackbars'
import { intelligentCompressImageForProfile } from './image-compression'

export async function uploadImage(
  file: File,
  onComplete: (info: { fileId: string; size: number }) => unknown,
) {
  showUploadingImageSnackbar()
  const image = await intelligentCompressImageForProfile(file)

  uploadFile({
    type: 'image',
    uploadId: uuidV4(),
    file: image,
    onComplete,
    onError: () =>
      showConnectionProblemSnackbar(() => uploadImage(file, onComplete)),
    retry: false,
    persist: false,
    queue: false,
  })
}
